import { Link } from 'react-router-dom';
import { pageMeta } from '../../constants/pageMeta';
import PolicyPage from '../components/PolicyPage';

const META = pageMeta('Page Not Found', 'The page you were looking for could not be found.', '/');

export default function NotFoundPage() {
  return (
    <PolicyPage title="Page Not Found" meta={META} showUpdated={false} showRelated={false}>
      <p>Sorry, we could not find that page. It may have moved or the link may be wrong.</p>
      <p>
        <Link to="/" className="fx-btn fx-btn--primary">
          Go to the home page
        </Link>
      </p>
    </PolicyPage>
  );
}
